module.exports = __webpack_public_path__ + "images/large-vertical-3b86d3356922569a961648d354f4c5af.jpg";